import objectToQueryString from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	getCommCodes: codeType => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getAsPartInfo: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		let startAplcDd;
		if (searchParams.stdDt !== undefined || searchParams.partNm !== undefined) {
			if (searchParams.stdDt) {
				startAplcDd = moment(searchParams.stdDt).format('YYYYMMDD');
			} else {
				startAplcDd = '';
			}

			queryStr = objectToQueryString({
				stdDt: startAplcDd,
				partNo: searchParams.partNo,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/qmsbase/partCost/v1/asPartInfos` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// 저장
	async postAsPartInfo({ saveParams }) {
		try {
			const response = await client.post(`${BASE_URL}/comm/qmsbase/partCost/v1/asPartInfo/status/2`, saveParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
